<template>
  <div class="user-container">
    <div class="app-container">
      <div class="rowContainer">
        <div class="treeSide">
          <div class="resize-bar"></div>
          <div class="resize-line">
            <svg-icon icon-class="dragIcon" icon-name="dragIcon"></svg-icon>
          </div>
          <div class="resize-save">
            <div class="head-container">
              <user-tree
                :get-tree-options="getTreeOptions"
                height="calc(100vh - 200px)"
                :show-refresh="true"
                :show-search="true"
                :draggable="true"
                :loading="treeLoading"
                :cancel-cur-select="false"
                :is-fefresh-child-node="refreshChildNode"
                @onChildNodeData="getChildNodeData"
                @getTreeRef="getUserTreeRef"
                @onNodeClick="handleNodeClick"
                @onRefreshTree="getTreeOptions"
                @cancelCurSelect="treeCancelCurSelect"
                @onRefreshChildNodeSuccess="onRefreshChildNodeSuccess"
              />
            </div>
          </div>
        </div>
        <div class="mainContent">
          <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
              <el-tooltip
                :content="
                  curOrganId === '' ? '请选择左侧的组织结构' : '新增用户'
                "
                effect="light"
                placement="bottom"
              >
                <div>
                  <el-button
                    :disabled="disabledAdd"
                    type="primary"
                    v-hasPermi="['system::accountManage::add']"
                    @click="handleAdd"
                    >新增
                  </el-button>
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
          <Table
            :data="tableData"
            ref="tableRef"
            :columns="columns"
            :total="curTotal"
            :loading="loading"
            :showFun="false"
            :isSelect="true"
            rowKey="applicationFormId"
            @onSearch="onSearch"
          />
        </div>
      </div>

      <!-- 添加或修改用户配置对话框 -->
      <el-dialog
        :title="dialogTitle"
        v-model="dialogOpen"
        width="1200px"
        append-to-body
      >
        <el-form
          ref="userFormRef"
          :model="userForm"
          :rules="userRules"
          label-width="120px"
        >
          <el-row>
            <el-col :span="16">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="用户账号" prop="userAccount">
                    <el-input
                      v-model="userForm.userAccount"
                      placeholder="请输入账户"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="用户姓名" prop="userName">
                    <el-input
                      v-model="userForm.userName"
                      placeholder="请输入姓名"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="身份证" prop="idCard">
                    <el-input
                      v-model="userForm.idCard"
                      placeholder="请输入身份证号码"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电话" prop="userTelnumber">
                    <el-input
                      v-model="userForm.userTelnumber"
                      placeholder="请输入电话"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="性别" prop="userGender">
                    <el-radio-group v-model="userForm.userGender">
                      <el-radio label="female">女</el-radio>
                      <el-radio label="male">男</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="民族" prop="userNation">
                    <el-input
                      v-model="userForm.userNation"
                      placeholder="请输入民族"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="邮箱" prop="userMail">
                    <el-input
                      v-model="userForm.userMail"
                      placeholder="请输入邮箱"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职位" prop="userPosition">
                    <el-input
                      v-model="userForm.userPosition"
                      placeholder="请输入职位"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="地址" prop="userAddress">
                    <el-input
                      v-model="userForm.userAddress"
                      placeholder="请输入地址"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="系统显示名称" prop="systemName">
                    <el-input
                      v-model="userForm.systemName"
                      placeholder="请输入系统显示名称"
                      maxlength="30"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div class="InputTree">
                <div>
                  <el-form-item label="所属用户">
                    <!-- <el-input v-model="userForm.userAccount" placeholder="请输入账户" maxlength="30" /> -->
                    <el-input v-model="curOrganName" disabled maxlength="30" />
                  </el-form-item>
                </div>
                <div class="addTree">
                  <user-tree
                    :tree-options="treeData"
                    :is-fefresh-child-node="refreshChildNode"
                    :showNotAllow="true"
                    @onNodeClick="handleAddTreeClick"
                    @onChildNodeData="getChildNodeData"
                    :cur-key="curKey"
                    @onRefreshChildNodeSuccess="onRefreshChildNodeSuccess"
                    @getTreeRef="getTreeRef"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="closed">{{
              $t("msg.universal.cancel")
            }}</el-button>
            <el-button type="primary" @click="onConfirm">{{
              $t("msg.universal.confirm")
            }}</el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 分配或修改角色对话框 -->
      <el-dialog
        :title="distributeDialogTitle"
        v-model="distributeDialogOpen"
        width="500px"
        append-to-body
      >
        <el-form :model="distributeDataForm" label-width="80px">
          <el-form-item label="用户名称">
            <el-input v-model="distributeDataForm.userName" :disabled="true" />
          </el-form-item>
          <el-form-item label="操作权限">
            <el-tree
              ref="distributeTreeRef"
              class="tree-border"
              :data="distributeOptions"
              show-checkbox
              default-expand-all
              node-key="roleId"
              empty-text="加载中，请稍等"
              :props="distributeProps"
            ></el-tree>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="closedDistribute">{{
              $t("msg.universal.cancel")
            }}</el-button>
            <el-button type="primary" @click="onConfirmDistribute">{{
              $t("msg.universal.confirm")
            }}</el-button>
          </span>
        </template>
      </el-dialog>
      <el-dialog
        title="重置密码"
        class="resetPwdDialog"
        v-model="resetPwdOpen"
        :close-on-click-modal="false"
        width="500px"
      >
        <div style="padding-left: 40px; color: red">
          请输入当前登陆人密码，重置密码为 123456
        </div>
        <el-form
          :rules="resetPasswordRules"
          :model="resetPasswordForm"
          ref="resetPasswordFromRef"
        >
          <div class="mt10" style="padding: 0px 40px; position: relative">
            <el-form-item prop="resetPassword">
              <el-input
                :type="passwordType"
                v-model="resetPasswordForm.resetPassword"
                placeholder="请输入密码"
              />
              <span class="show-pwd" @click="onChangePwdType">
                <svg-icon
                  :icon="passwordType === 'password' ? 'eye' : 'eye-open'"
                />
              </span>
            </el-form-item>
          </div>
        </el-form>

        <template #footer>
          <FootBtn
            class="mt10"
            @onClosed="handleResetPwdclosed"
            @onConfirm="handleResetPwdConfirm"
          />
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref, watch } from "vue";
import { newGetSimpleTress } from "@/api/system/organ";
import {
  addRole,
  findUserByOrganIds,
  getRole,
  modifyUser,
  removeUser,
  saveUser,
  resetPwd,
} from "@/api/system/user";
import { joinComma } from "@/utils/stringutil";
import usePermissionStore from "@/store/modules/permission";
import useSystemStore from "@/store/modules/system";
import { relAdd, relDelete } from "@/api/system/mechanism";
import { alertBox } from "@/utils/msgBox.ts";
import { confirmBox, succesMsg } from "@/utils/msgBox.ts";
// import DataTable from "@/components/table/dataTable"
import Table from "@/components/Element/Table";
import UserTree from "@/components/userTree";
import { getCustomTableCols } from "@/tableColumn";
import { findUserInfo } from "@/api/system/user";
import FootBtn from "@/components/Element/DialogFootBtn";
import useAccountStore from "@/store/modules/account";

const accountStore = useAccountStore();
const store = usePermissionStore();
const store_sys = useSystemStore();

// 表格参数
const tableRef = ref([]);
const tableData = ref([]);
const loading = ref(false);

const curPage = ref(1);
const curSize = ref(20);
const curTotal = ref(0);
defineOptions({
  name: "accountManage",
});
const { proxy, appContext } = getCurrentInstance();

const organFilterText = ref("");
// 部门树选项
const organOptions = ref([]);

// 当前节点
const curOrganId = ref("");

//
const defaultProps = {
  children: "children",
  label: "name",
};
const disabledAdd = ref(true);
const treeRef = ref(null);
watch(
  () => organFilterText.value,
  (newVal, oldVal) => {
    treeRef.value.filter(newVal);
  }
);

const organFilterNode = (value, data) => {
  if (!value) return true;
  return data.name.indexOf(value) !== -1;
};

// 查询参数
const queryParams = ref({
  userName: undefined,
  userIdCode: undefined,
  organIds: undefined,
});

// 用户表格数据
const userList = ref([]);
// 表格总数
const total = ref(0);
let userTreeRef = null;
const curKey = ref("");
const curOrganName = ref("");
const getUserTreeRef = (treeRef) => {
  userTreeRef = treeRef;
};
let _treeRef = null;
const getTreeRef = (treeRef) => {
  _treeRef = treeRef;
};
// 获取节点树
const treeOptions = ref([]);
const treeData = ref("");
const treeLoading = ref(true);
const getTreeOptions = async () => {
  treeOptions.value = await newGetSimpleTress().then((resData) => {
    treeLoading.value = false;
    store.permissionTrees = resData.data;
    const expandData = filterExpandData(resData.data);
    return expandData;
  });
  treeData.value = treeOptions.value;
  return treeOptions.value;
};
//获取子节点
const getChildNodeData = (data) => {
  const expandData = filterExpandData(data[0]?.child);
};
const filterExpandData = (data) => {
  data?.forEach((item) => {
    if (item.hasChild == "1") {
      let child = [
        {
          organId: "xnzjd0001" + item.organId,
          organName: "正在加载",
          child: [],
        },
      ];
      item.child = child;
    }
  });
  return data;
};
// 刷新子节点完成
const refreshChildNode = ref(false);
const onRefreshChildNodeSuccess = () => {
  refreshChildNode.value = false;
};

const whetherPermisition = ref("false"); // 按钮点击标志
const refreshNodeData = ref({});
const curNodeOri = ref(null);
const nodeClickFlag = ref(false); // 按钮点击标志
// 节点被点击
const curParentNode = ref(null);
let curNodeItem = null;
const handleNodeClick = async (data, nodeItem) => {
  if (data.isCanAdd == "1") {
    disabledAdd.value = false;
  } else {
    disabledAdd.value = true;
  }
  curNodeOri.value = nodeItem;
  curOrganName.value = data.organName;
  if (curNodeOri.value) {
    refreshNodeData.value = curNodeOri.value.data;
    refreshChildNode.value = true;
  }
  // 点击节点上的按钮，修改点击状态返回
  if (nodeClickFlag.value) {
    nodeClickFlag.value = false;
    return;
  }
  curParentNode.value = data;
  if (curNodeItem && curNodeItem === nodeItem) {
    curNodeItem = null;
    curOrganId.value = "";
    queryParams.value.organId = "";
    queryParams.value.nodeType = "";
    whetherPermisition.value = "";
    curKey.value = "";
    userTreeRef.setCurrentKey(null);
  } else {
    curNodeItem = nodeItem;
    curOrganId.value = data.id;
    whetherPermisition.value = data.whetherPermisition;
    queryParams.value.organId = data.organId;
    queryParams.value.nodeType = data.nodeType;
    curKey.value = data.organId;
  }

  tableRef.value.onSearch();
};
// 点击取消当前选择
const treeCancelCurSelect = () => {
  curParentNode.value = null;
  tableRef.value.onSearch(); // 获取表格数据
};

const handleAddTreeClick = (data, nodeItem) => {
  userForm.value.organId = data.organId;
  whetherPermisition.value = data.whetherPermisition;
  curOrganName.value = data.organName;
};

// 新增用户
const handleAdd = () => {
  dialogTitle.value = "新增用户";
  dialogUserReset();
  userForm.value.organId = queryParams.value.organId;
  userForm.value.userGender = "male";
  // userForm.value.admin = 0
  dialogOpen.value = true;
};
// 修改用户
const handleUpdate = (row, node) => {
  dialogUserReset(); // 重置数据
  findUserInfo(node.userId).then((data) => {
    dialogTitle.value = "修改用户";
    curOrganName.value = data.data.organizationNode.organName; //节点名称
    dialogUserReset(); // 重置数据
    userForm.value = { ...node };
    userForm.value.organId = queryParams.value.organId;
    dialogOpen.value = true;
  });
};

// 删除
const handleDelete = (row, node) => {
  confirmBox("是否确定要删除该用户")
    .then(async () => {
      await removeUser(node).then((resData) => {
        if (resData.status === 1) {
          tableRef.value.onSearch();
          succesMsg("删除成功");
          getTreeOptions();
        }
      });
    })
    .catch((err) => {});
};

const resetPwdOpen = ref(false);
const resetPasswordForm = ref({
  resetPassword: "",
});
const resetPasswordFromRef = ref(null);

let resetPwdUser = null;

const resetPasswordRules = ref({
  resetPassword: [
    { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" },
  ],
});

// 处理密码框文本显示
const passwordType = ref("password");
// tempalte 中绑定的方法，直接声明即可
const onChangePwdType = () => {
  // 当 passwordType 的值为 password 的时候，改为 text
  // 使用ref 声明的数据，在 script 中使用时，需要加 value 来获取具体的值，但是在tempalte 中使用的时候，不需要加 value
  if (passwordType.value === "password") {
    passwordType.value = "text";
  } else {
    passwordType.value = "password";
  }
};
// 重置密码
const handleResetPassword = (event, row) => {
  resetPwdUser = row;
  resetPwdOpen.value = true;
};
// 关闭
const handleResetPwdclosed = () => {
  resetPwdOpen.value = false;
};

// 提交
const handleResetPwdConfirm = () => {
  // 校验数据是否合规
  resetPasswordFromRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    resetPwd({
      userId: resetPwdUser.userId,
      adminPassword: resetPasswordForm.value.resetPassword,
    }).then((res) => {
      succesMsg("重置成功");
      handleResetPwdclosed();
    });
  });
};

// 搜索按钮操作
const onSearch = async (data) => {
  curPage.value = data.pageIndex;
  curSize.value = data.pageSize;

  loading.value = true;
  await findUserByOrganIds({
    ...data,
    ...queryParams.value,
  })
    .then((resData) => {
      tableData.value = resData.data;
      curTotal.value = resData.pageParam.totleInfo || 0;
    })
    .finally(() => {
      loading.value = false;
    });
};

// 对话框参数
const dialogTitle = ref("");
// 是否显示对话框
const dialogOpen = ref(false);
// 表单组件
const userFormRef = ref(null);
// 表单数据
const userForm = ref({});
// 表单规则
const userRules = {
  userAccount: [
    {
      required: true,
      message: "账户不能为空",
      trigger: "blur",
    },
    {
      pattern: /^[A-Za-z0-9_]{4,}$/,
      message: "可以包含 字母数字下划线，最少四位",
      trigger: "blur",
    },
  ],
  userName: [
    {
      required: true,
      message: "姓名不能为空",
      trigger: "blur",
    },
  ],
  userNode: [
    {
      required: true,
      message: "用户节点不能为空",
      trigger: "blur",
    },
  ],
  userTelnumber: [
    {
      pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      message: "请输入正确的手机号码",
      trigger: "blur",
    },
  ],
  userMail: [
    {
      type: "email",
      message: "请输入正确的邮箱地址",
      trigger: ["blur", "change"],
    },
  ],
};

const searchLoading = ref(false);
const searchOptions = ref();
const searchValue = ref("");

// 重置数据
const dialogUserReset = () => {
  userForm.value = {};
};
// 关闭
const closed = () => {
  dialogOpen.value = false;
};

// 提交
const onConfirm = () => {
  userFormRef.value.validate((valid) => {
    if (!valid) return;
    if (whetherPermisition.value == "0") {
      warnMsg("用户无此节点权限");
      return;
    }
    let resStatus = false;
    // 修改
    if (userForm.value.userId) {
      modifyUser(userForm.value).then((resData) => {
        if (resData.status === 1) {
          closed();
          tableRef.value.onSearch();
        }
      });
    } else {
      // 新增
      saveUser(userForm.value).then((resData) => {
        if (resData.status === 1) {
          closed();
          tableRef.value.onSearch();
        }
      });
    }
    getTreeOptions();
  });
};

// 设置数据权限对话框
// 参数
const dataDialogTitle = ref("");
const dataDialogOpen = ref(false);
const curUserInfo = ref({});

const dataDataForm = ref({});
const dataOptions = ref([]);
const dataProps = {
  children: "child",
  label: "organName",
};

// 数据权限
const rootNodeId = ref("");
const handleData = async (row, node) => {
  curUserInfo.value = node;
  dataDialogOpen.value = true;
};
// 迭代查找选中的子节点
const nodeIteration = (allNodes, checkNodes) => {
  const nodes = [];
  allNodes.forEach((node) => {
    if (checkNodes.indexOf(node.organId) !== -1) {
      if (node.child && node.child.length > 0) {
        nodes.push(...nodeIteration(node.child, checkNodes));
      } else {
        nodes.push(node.organId);
      }
    }
  });
  return nodes;
};

// 关闭数据权限
const closedData = () => {
  dataDialogOpen.value = false;
};

// 提交数据权限
const onConfirmData = async () => {
  dataDataForm.value.permissionType = "company";
  // 删除关联
  relDelete(dataDataForm.value.userId).then((resData) => {
    if (resData.status === 1 && dataDataForm.value.relId !== "") {
      // 增加关联
      const addData = { ...dataDataForm.value };
      addData.relId = addData.relId.join(",");
      relAdd(addData).then((resData1) => {
        if (resData1.status === 1) {
          closedData();
        }
      });
    } else {
      alertBox("未配置数据权限", "确定");
      closedData();
    }
  });
};

// 分配权限对话框
// 参数
const distributeDialogTitle = ref("");

const distributeDialogOpen = ref(false);
const distributeDataForm = ref({});
const distributeOptions = ref([]);
const distributeTreeRef = ref(null);
const distributeProps = {
  children: "children",
  label: "roleName",
};

const resetDistributeDataForm = () => {
  distributeDataForm.value.userId = "";
  distributeDataForm.value.userName = "";
  distributeDataForm.value.roleId = "";
};

// 获取所有操作
const getAllOperation = async () => {
  distributeOptions.value = await store_sys.getAllRoles();
};

// 分配权限
const handleDistribution = async (row, node) => {
  distributeDialogOpen.value = true;
  resetDistributeDataForm(); // 重置数据
  getAllOperation(); // 获取所有操作
  distributeDataForm.value.userId = node.userId;
  distributeDataForm.value.userName = node.userName;
  // 获取当前用户下所有角色
  await getRole({
    userId: node.userId,
  }).then((resData) => {
    distributeTreeRef.value.setCheckedKeys(resData, false);
  });
};

// 关闭分配许可
const closedDistribute = () => {
  distributeTreeRef.value.setCheckedKeys([], false);
  distributeDialogOpen.value = false;
};

// 提交许可
const onConfirmDistribute = async () => {
  // 全选中节点
  const checkedKeys = distributeTreeRef.value.getCheckedKeys(false);
  let distributeIds = joinComma("", checkedKeys);

  distributeDataForm.value.roleId = distributeIds;

  await addRole(distributeDataForm.value).then((resData) => {
    if (resData.status === 1) {
      closedDistribute();
    }
  });
};

const columns = [
  {
    label: "账户",
    prop: "userAccount",
    sortable: "custom",
    itemMinWidth: "260",
  },
  {
    label: "名称",
    prop: "userName",
    sortable: "custom",
    itemMinWidth: "260",
  },
  {
    label: "角色",
    prop: "roleNames",
    sortable: "custom",
    itemMinWidth: "260",
  },
  // "userAccount",
  // "userName",
  // "userAddress",
  {
    label: "操作",
    prop: "action",
    type: "action",
    fixed: "right",
    itemWidth: "220",
    search: false,
    action: [
      {
        control: "button",
        controlName: "分配角色",
        controlType: "text",
        controlText: true,
        controlPermission: ["system::accountManage::distribution"],
        controlFun: handleDistribution,
      },
      {
        control: "button",
        controlName: "修改",
        controlType: "text",
        controlText: true,
        controlPermission: ["system::accountManage::update"],
        controlFun: handleUpdate,
      },
      {
        control: "button",
        controlName: "删除",
        controlType: "text",
        controlText: true,
        controlPermission: ["system::accountManage::delete"],
        controlFun: handleDelete,
      },
    ],
  },
];

if (accountStore.userInfo.admin === "1") {
  columns[columns.length - 1].action.push({
    control: "button",
    controlName: "重置密码",
    controlType: "text",
    controlFun: handleResetPassword,
  });
}
</script>

<style scoped lang="scss">
.user-container {
  .app-container {
    overflow: hidden;
    padding-right: 0px;
    .rowContainer {
      display: flex;
      .treeSide {
        position: relative;
        .resize-bar {
          width: 300px;
          min-width: 300px;
          height: inherit;
          resize: horizontal;
          cursor: col-resize;
          opacity: 0;
          overflow: scroll;
          max-width: 700px;
        }
        .resize-save {
          position: absolute;
          top: 0;
          right: 5px;
          bottom: 0;
          left: 0;
          padding: 16px;
          overflow: hidden;
        }
        .resize-line {
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          border-right: 1px double #bbb;
          // border-left: 1px double #bbb;
          width: 15px;
          pointer-events: none;
          display: flex;
          justify-content: center;
          align-items: center;
          .dragIcon {
            transform: rotate(90deg);
            // display: none !important;
            :deep(.svg-icon) {
              width: 3em !important;
            }
          }
        }
        .resize-bar:hover ~ .resize-line,
        .resize-bar:active ~ .resize-line {
          // border-left: 1px dashed skyblue;
          border-right: 1px dashed skyblue;
        }
        .resize-bar::-webkit-scrollbar {
          width: 200px;
          height: calc(100vh - 200px);
        }
      }
      .mainContent {
        box-sizing: border-box;
        overflow: hidden;
        flex: 1;
        padding-left: 10px;
      }
    }
  }

  .el-scrollbar {
    margin-top: 10px;
  }
}
.addTree {
  padding: 0 10px 0 20px;
}
.InputTree {
  border-left: 1px solid #e5e5e5;
  margin-left: 25px;
  :deep(.el-form-item__label) {
    width: 100px !important;
  }
}

:deep(.resetPwdDialog:not(.is-fullscreen)) {
  margin-top: 36vh !important;
}

.show-pwd {
  position: absolute;
  right: 5px;
  z-index: 1;
}
</style>
